import(/* webpackMode: "eager" */ "/app/apps/backoffice-app/app/error.tsx")